export const company = {
  name: 'SGSCTIC',
  tagline: 'Partenaire industriel au Cameroun',
  baseline:
    "Expertise en chaudronnerie, tuyauterie et soudure pour un développement industriel durable et sécurisé.",
  address: 'Rails Logbaba — Douala, Cameroun',
  phone: '+237 6 98 99 41 51',
  phoneHref: 'tel:+237698994151',
  email: 'infos@sgsctic.com',
  hours: 'Lundi — Vendredi, 07h30 – 17h30',
};

export const whatsapp = {
  number: '237698994151',
  display: '+237 6 98 99 41 51',
};

export const navigation = [
  { label: 'Accueil', path: '/' },
  { label: 'À propos', path: '/a-propos' },
  { label: 'Offres', path: '/offres' },
  { label: 'Réalisations', path: '/realisations' },
  { label: 'Formation', path: '/formation' },
  { label: 'Actualités', path: '/actualites' },
  { label: 'Contact', path: '/contact' },
];

export const marqueeWords = [
  'Chaudronnerie',
  'Tuyauterie',
  'Soudure TIG / MIG',
  'Montage industriel',
  'Maintenance',
  'Peinture anticorrosion',
  'Formation',
  'Échafaudage',
];

export const stats = [
  { value: 10, suffix: '', label: "Domaines d'expertise", hint: 'Un seul interlocuteur' },
  { value: 3, suffix: '', label: 'Métiers historiques', hint: 'Chaudronnerie · tuyauterie · soudure' },
  { value: 2, suffix: '', label: 'Bassins couverts', hint: 'Cameroun & sous-région' },
  { value: 100, suffix: '%', label: 'Traçabilité qualité', hint: 'Contrôle à chaque étape' },
];

export const values = [
  {
    title: 'Expertise',
    icon: 'ri-hammer-line',
    text:
      "Des services d'une qualité exceptionnelle, soutenus par une expertise approfondie dans chacun de nos domaines d'activité.",
  },
  {
    title: 'Qualité',
    icon: 'ri-shield-check-line',
    text:
      "Chaque projet est mené avec précision et attention aux détails : traçabilité, contrôle et satisfaction client.",
  },
  {
    title: 'Sécurité',
    icon: 'ri-shield-star-line',
    text:
      "La sécurité de nos équipes et de nos clients est prioritaire, avec des protocoles stricts sur chaque site.",
  },
  {
    title: 'Engagement',
    icon: 'ri-team-line',
    text:
      "Un interlocuteur unique du premier relevé à la mise en service, pour des projets industriels sans zone d'ombre.",
  },
];

export const processSteps = [
  {
    number: '01',
    title: 'Diagnostic & relevé',
    text:
      "Visite de site, écoute de votre besoin et relevé dimensionnel. Nous cadrons les contraintes techniques, d'accès et de sécurité.",
  },
  {
    number: '02',
    title: 'Étude & chiffrage',
    text:
      "Plans, choix des matériaux, procédés de soudure et séquencement. Vous recevez une proposition claire et détaillée.",
  },
  {
    number: '03',
    title: 'Fabrication & exécution',
    text:
      "Préfabrication en atelier de Logbaba, puis montage sur site par nos équipes, dans le respect du planning et des règles HSE.",
  },
  {
    number: '04',
    title: 'Contrôle & mise en service',
    text:
      "Vérifications dimensionnelles, contrôles d'étanchéité et de finition, réception avec vous puis mise en service.",
  },
];

export const sectors = [
  { title: 'Pétrole & gaz', icon: 'ri-oil-line' },
  { title: 'Mines & carrières', icon: 'ri-roadster-line' },
  { title: 'Agro-industrie', icon: 'ri-plant-line' },
  { title: 'Énergie', icon: 'ri-flashlight-line' },
  { title: 'Cimenterie', icon: 'ri-building-4-line' },
  { title: 'Logistique portuaire', icon: 'ri-ship-line' },
  { title: 'BTP & infrastructures', icon: 'ri-building-2-line' },
  { title: 'Industries manufacturières', icon: 'ri-settings-5-line' },
];

export const gallery = [
  {
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-07-at-13.05.04.png',
    caption: 'Équipe SGSCTIC sur chantier',
    tall: false,
  },
  {
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.05.26-1.jpeg',
    caption: 'Assemblage de structure métallique',
    tall: true,
  },
  {
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.05.23.jpeg',
    caption: 'Préparation de supportage',
    tall: false,
  },
  {
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.04.28.jpeg',
    caption: 'Montage sur site industriel',
    tall: false,
  },
  {
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.39.37-1.jpeg',
    caption: 'Soudure en atelier',
    tall: true,
  },
];

export const faqs = [
  {
    question: 'Intervenez-vous en dehors de Douala ?',
    answer:
      "Oui. Nos équipes travaillent à Douala et sur l'ensemble du territoire camerounais, ainsi que dans la sous-région. Les déplacements sont étudiés au cas par cas selon la nature du chantier et sa durée.",
  },
  {
    question: 'Comment obtenir un devis pour mon projet ?',
    answer:
      "Envoyez-nous vos plans, photos ou un simple descriptif du besoin via le formulaire de contact. Nous revenons vers vous pour préciser les contraintes, puis nous établissons une proposition détaillée : matériaux, procédés, délais et conditions d'intervention.",
  },
  {
    question: 'Réalisez-vous aussi de petites interventions ?',
    answer:
      "Oui. À côté des ouvrages neufs, nous assurons les réparations, reprises de soudure, remplacements de tronçons et interventions de maintenance ponctuelle sur des équipements existants.",
  },
  {
    question: 'Proposez-vous des formations pour des équipes externes ?',
    answer:
      "Nos formations en chaudronnerie, tuyauterie, soudure, montage et échafaudage sont ouvertes aux entreprises qui souhaitent qualifier leurs propres collaborateurs. Elles se déroulent en théorie et en pratique, avec une évaluation en fin de session.",
  },
  {
    question: 'Quelles garanties apportez-vous sur la qualité ?',
    answer:
      "Les soudures sont réalisées selon des modes opératoires définis, puis contrôlées. Les matériaux et fournitures sont tracés, et chaque ouvrage fait l'objet d'une réception documentée avec le client avant mise en service.",
  },
];

export const testimonials = [
  {
    quote:
      "SGSCTIC a transformé notre expérience industrielle grâce à leur savoir-faire exceptionnel et un service client impeccable.",
    name: 'Henry',
    role: 'Client industriel',
    image:
      'https://sgsctic.com/wp-content/uploads/2025/03/testimonial-skip-01.jpeg',
  },
];